import { render, staticRenderFns } from "./cg-event-filter.vue?vue&type=template&id=0d332c96&scoped=true"
import script from "./cg-event-filter.vue?vue&type=script&lang=js"
export * from "./cg-event-filter.vue?vue&type=script&lang=js"
import style0 from "./cg-event-filter.vue?vue&type=style&index=0&id=0d332c96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d332c96",
  null
  
)

export default component.exports